import type { ChangeEvent, MouseEvent, KeyboardEvent } from "react"
import React, { useState } from "react"
import axios, { type AxiosError } from "axios"
import "./cta.scss"

// Email validation helper function
const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email.trim())
}

// TODO: Leverage Card component
export const CallToAction = () => (
  <div className="cta">
    <div className="cta-green-square" />
    <div className="cta-yellow-square" />
    <div className="cta-orange-square" />
    <div className="cta-purple-square" />
    <div className="overflow-hidden max-w-sm rounded shadow-lg cta-card">
      <h3>Get Updates Delivered to Your Inbox</h3>
      <FormContent />
    </div>
  </div>
)

const FormContent = () => {
  const [email, setEmail] = useState(``)
  const [isSubscribed, setIsSubscribed] = useState(false)
  const [emailError, setEmailError] = useState(``)

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newEmail = event.target.value
    setEmail(newEmail)

    // Clear error when user starts typing
    if (emailError) {
      setEmailError(``)
    }
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === `Enter`) {
      event.preventDefault()
      subscribe()
    }
  }

  const subscribe = async (event?: MouseEvent<HTMLButtonElement>) => {
    event?.preventDefault()

    // Validate email before submitting
    const trimmedEmail = email.trim()

    if (!trimmedEmail) {
      setEmailError(`Please enter your email address.`)
      return
    }

    if (!isValidEmail(trimmedEmail)) {
      setEmailError(`Please enter a valid email address.`)
      return
    }

    const data = {
      fields: [{ name: `email`, value: trimmedEmail }],
    }
    const portalId = `8186536`
    const formId = `b61423e5-1949-4ebc-965d-63c1c7fb723e`
    const url = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`

    try {
      await axios({
        method: `post`,
        url,
        data,
        headers: {
          "Content-Type": `application/json`,
        },
      })

      setEmail(``)
      setEmailError(``)
      setIsSubscribed(true)
    } catch (err: unknown) {
      const error = err as AxiosError<{ errors: Array<{ errorType: string }> }>
      const errorType = error.response?.data?.errors?.[0]?.errorType
      switch (errorType) {
        case `INVALID_EMAIL`:
          setEmailError(`Please enter a valid email address.`)
          break
        case `REQUIRED_FIELD`:
          setEmailError(`Please enter your email address.`)
          break
        default:
          setEmailError(`An error occurred. Please try again.`)
      }
    }
  }

  if (isSubscribed) {
    return (
      <p className="subscribed-text">Thanks for signing up to get updates!</p>
    )
  }

  return (
    <div className="input-button-group">
      <div className="flex flex-col flex-1">
        <input
          value={email}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          placeholder="Email Address"
          className={emailError ? `border-red-500 error` : ``}
          aria-invalid={emailError ? `true` : `false`}
          aria-describedby={emailError ? `email-error` : undefined}
        />
        {emailError && (
          <p
            id="email-error"
            className="mt-2 text-sm text-red-500"
            role="alert"
          >
            {emailError}
          </p>
        )}
      </div>
      <button onClick={subscribe}>Subscribe</button>
    </div>
  )
}
